import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "control-sidebar control-sidebar-dark",
  style: {"padding":"16px","padding-top":"73px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Customize AdminLTE", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-2" }, null, -1)
const _hoisted_4 = { style: {"padding":"8px 0"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Dark mode ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Light Navbar Variants ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Dark Navbar Variants ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Accent Color Variants ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Light Sidebar Variants ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Dark Sidebar Variants ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Brand Logo Variants ")

export function render(_ctx, _cache) {
  const _component_pf_checkbox = _resolveComponent("pf-checkbox")
  const _component_pf_select = _resolveComponent("pf-select")

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_pf_checkbox, { onChange: _ctx.handleDarkModeChange }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onChange"]),
      _createVNode(_component_pf_select, {
        label: "Light Navbar Variants",
        value: _ctx.navbarVariant,
        class: "mt-3",
        options: _ctx.navbarLightVariants,
        type: "custom",
        onChange: _ctx.onNavbarVariantChange
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["value", "options", "onChange"]),
      _createVNode(_component_pf_select, {
        label: "Dark Navbar Variants",
        value: _ctx.navbarVariant,
        class: "mt-3",
        options: _ctx.navbarDarkVariants,
        type: "custom",
        onChange: _ctx.onNavbarVariantChange
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["value", "options", "onChange"]),
      _createVNode(_component_pf_select, {
        label: "Accent Color Variants",
        class: "mt-3",
        options: [],
        type: "custom",
        disabled: ""
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_pf_select, {
        label: "Light Sidebar Variants",
        class: "mt-3",
        value: _ctx.sidebarSkin,
        options: _ctx.lightSidebarSkins,
        type: "custom",
        onChange: _ctx.onSidebarSkinChange
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["value", "options", "onChange"]),
      _createVNode(_component_pf_select, {
        label: "Dark Sidebar Variants",
        class: "mt-3",
        value: _ctx.sidebarSkin,
        options: _ctx.darkSidebarSkins,
        type: "custom",
        onChange: _ctx.onSidebarSkinChange
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["value", "options", "onChange"]),
      _createVNode(_component_pf_select, {
        label: "Brand Logo Variants",
        class: "mt-3",
        options: [],
        type: "custom",
        disabled: ""
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      })
    ])
  ]))
}